import { useEffect } from 'react';
import type { ToolId } from './tools';

const SHORTCUTS: Record<string, ToolId> = {
  v: 'select',
  h: 'hand',
  s: 'sticky',
  t: 'text',
  r: 'rect',
  o: 'ellipse',
  a: 'arrow',
  f: 'frame',
  p: 'pen',
  i: 'image',
};

// Single-letter tool switches. Only fire on plain key presses (no modifiers)
// and only when the user is not typing in a real input. The Esc / Delete
// keys are handled inside Canvas because they need direct access to drag /
// create / edit state.
export function useToolShortcuts(setActiveTool: (tool: ToolId) => void) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const target = e.target as HTMLElement | null;
      if (target && isFormField(target)) return;
      const key = e.key.toLowerCase();
      const tool = SHORTCUTS[key];
      if (!tool) return;
      e.preventDefault();
      setActiveTool(tool);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setActiveTool]);
}

function isFormField(el: HTMLElement): boolean {
  const tag = el.tagName;
  if (tag === 'TEXTAREA' || tag === 'INPUT') return true;
  return el.isContentEditable;
}
